export default __webpack_public_path__ + "static/media/David Cohen.e61d8253.jpg";